// @ts-nocheck
import { BreakpointKey } from "@insite/mobius/utilities/breakpointMediaQueries";
import getBreakpointIndex from "@store/Framework/Common/Utilities/getBreakpointIndex";
import { MediaOption } from "@store/Framework/Common/Utilities/mediaQueries";
import { StyledTheme } from "@toolkit/Framework/Types/StyledTheme";

const isBreakpoint = (
    theme: StyledTheme,
    currentBreakpoint: BreakpointKey | undefined,
    targetBreakpoint: BreakpointKey,
    mediaOption: MediaOption = "only",
) => {
    if (!currentBreakpoint) {
        return false;
    }

    const currentBreakpointIndex = getBreakpointIndex(currentBreakpoint, theme);
    const targetBreakpointIndex = getBreakpointIndex(targetBreakpoint, theme);

    switch (mediaOption) {
        case "up":
            return currentBreakpointIndex >= targetBreakpointIndex;
        case "down":
            return currentBreakpointIndex <= targetBreakpointIndex;
        default:
            return currentBreakpointIndex === targetBreakpointIndex;
    }
};

export default isBreakpoint;
